<template>
<a href="/mine/index.html" :data-scp="scp">
	<i class="icon" :class="current ? 'icon-member-current' : 'icon-member'"></i><span>我的</span><sub v-if="getNew"></sub>
</a>
</template>

<script>
export default {
	props: ['scp', 'current']
	, data: function(){
		return {
			getNew: false
		}
	}
	, events: {
		getNewMsg: function(msgType){
			if( msgType === 'member' ){
				this.$set('getNew', true);
			}
		}
	}
}
</script>